import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { AppState } from 'src/app/@store/app.reducers';
import { isStringNullOrEmpty } from 'src/app/helper/seguros-atlas/seguros-atlas.helper';
import { ResultApiResponse } from 'src/app/models/complementos-web/complementos-web-servicios.model';
import { ActualizaTerminoSiniestroOutput, ConsultaFechasOutput, ConsultaResumenSiniestroOutput, ConsultaSiniestroOutput, MotivoChecksResumen, MotivosResumen, SiniestroComplemento, SiniestroDet, VerificaTerminoSiniestroOutput } from 'src/app/models/complementos-web/complementos-web.model';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCardContent, MatCardActions } from '@angular/material/card';
import { DetalleSiniestroResumenComponent } from '../../@components/detalle-siniestro-resumen/detalle-siniestro-resumen.component';
import { SubtituloSeccionComplementoComponent } from '../../@components/subtitulo-seccion-complemento/subtitulo-seccion-complemento.component';
import { DetalleTablaServiciosSiniestroResumenComponent } from '../../@components/detalle-tabla-servicios-siniestro-resumen/detalle-tabla-servicios-siniestro-resumen.component';
import { DetalleTablaPagosRecuperacionesResumenComponent } from '../../@components/detalle-tabla-pagos-recuperaciones-resumen/detalle-tabla-pagos-recuperaciones-resumen.component';
import { DetalleTablaOcupantesResumenComponent } from '../../@components/detalle-tabla-ocupantes-resumen/detalle-tabla-ocupantes-resumen.component';
import { DetalleTablaCoberturasSiniestroResumenComponent } from '../../@components/detalle-tabla-coberturas-siniestro-resumen/detalle-tabla-coberturas-siniestro-resumen.component';

import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatError, MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-ver-resumen-siniestro',
    templateUrl: './modal-ver-resumen-siniestro.component.html',
    styleUrls: ['./modal-ver-resumen-siniestro.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCardContent, DetalleSiniestroResumenComponent, SubtituloSeccionComplementoComponent, DetalleTablaServiciosSiniestroResumenComponent, DetalleTablaPagosRecuperacionesResumenComponent, DetalleTablaOcupantesResumenComponent, DetalleTablaCoberturasSiniestroResumenComponent, FormsModule, ReactiveFormsModule, MatCheckbox, MatRadioGroup, MatRadioButton, MatError, MatFormField, MatLabel, MatInput, MatHint, MatButton, MatCardActions]
})
export class ModalVerResumenSiniestroComponent implements OnInit {

  public formularioResumen: FormGroup;
  public detalleSiniestroResumen: any = {};
  public motivosDisponibles: number[] = [];
  public filasMotivo: MotivoChecksResumen[] = [];
  public mostrarObservaciones = true;
  public mostrarTablaMotivos = false;
  public motivoSeleccionado = 0;

  public siniestroResumenSiniestro: SiniestroDet;
  public siniestroDetalleCompleto: ConsultaSiniestroOutput;

  public serviciosAsegurado = new MatTableDataSource([]);
  public serviciosTercero = new MatTableDataSource([]);
  public ocupantesAsegurado = new MatTableDataSource([]);
  public ocupantesTercero = new MatTableDataSource([]);
  public pagos = new MatTableDataSource([]);
  public recuperaciones = new MatTableDataSource([]);
  public coberturasSiniestro = new MatTableDataSource([]);
  public tercerosSiniestro = new MatTableDataSource([]);
  public estimacionesSiniestro = {
    estimacion: null,
    estimacionRCO: null
  };

  constructor(
    public dialogRef: MatDialogRef<ModalVerResumenSiniestroComponent>,
    private store: Store<AppState>,
    private complementosWebService: ComplementoWebService,
    private router: Router,
    private procesosComplementoService: ProcesosComunesComplementoService,
    @Inject(MAT_DIALOG_DATA) public data: { siniestro: SiniestroDet, siniestroDetalle: ConsultaSiniestroOutput, fechasDetalle: ConsultaFechasOutput },
  ) {
    this.siniestroResumenSiniestro = this.data.siniestroDetalle.Siniestro[0];
    console.log(this.data)
  }

  ngOnInit(): void {
    this.cargarFormulario();
    this.consultarSiniestroResumen();
  }

  cargarFormulario() {
    this.formularioResumen = new FormGroup({
      observaciones: new FormControl(null, Validators.required),
      sinCosto: new FormControl(undefined),
      motivoCosto: new FormControl(undefined),
    });
    if (this.data.siniestroDetalle.Siniestro[0].estatus != 4) {
      this.formularioResumen.disable({ emitEvent: false });
    }
  }

  closeDialog(opcion: string, valor?) {
    if (opcion == 'Cancelar') this.dialogRef.close(valor);
    if (opcion == 'Aceptar') this.dialogRef.close(valor);
  }

  onSinCostoChange(event: MatCheckboxChange) {
    const isChecked = event.checked;
    if (isChecked) {
      this.formularioResumen.get('motivoCosto').setValidators(Validators.required);
    } else {
      this.formularioResumen.get('motivoCosto').setValidators(null);
    }
    this.formularioResumen.get('motivoCosto').updateValueAndValidity();
  }

  cargaTablaMotivos() {
    let responsable = this.siniestroResumenSiniestro.respons_sini;
    let serie = this.siniestroResumenSiniestro.serie;
    let estatus = this.siniestroResumenSiniestro.estatus;
    let motivo = this.siniestroResumenSiniestro.cve_sin_costo;
    this.ccnfigurarTablaMotivos(estatus, serie, responsable, motivo);
  }

  ccnfigurarTablaMotivos(Estatus: number, Serie: string | null, Responsable: number, Motivo: number) {
    if (Estatus === 4) {
      //Valida que este guardada la información de complemento general
      this.motivosDisponibles = Serie === null ? [2, 3, 4, 5, 6] : [1, 7, 8];
      if (Serie !== null && Responsable !== 3) {
        this.motivosDisponibles.push(6);
      }

      // Filtra la tabla quitando los motivos excluidos
      const filasMotivosCheck = this.filasMotivo.filter(fila => !this.motivosDisponibles.includes(fila.valor_dato));
      this.filasMotivo = filasMotivosCheck
    } else {
      // Solo mantiene el motivo actual
      const filasMotivosCheck = this.filasMotivo.filter(fila => fila.valor_dato === Motivo);
      this.filasMotivo = filasMotivosCheck
      this.mostrarObservaciones = false;
    }

    if (Motivo !== 0) {
      this.configuraTablaMotivos(1);
      this.formularioResumen.get('sinCosto').setValue(true);
      this.formularioResumen.get('motivoCosto').setValue(Motivo);
      this.filasMotivo[0].checked = true;
    }

    console.log(this.formularioResumen.value, Motivo, this.filasMotivo)
  }

  configuraTablaMotivos(motivo: number) {
    if (motivo == 1) {
      this.formularioResumen.get('motivoCosto').setValidators(Validators.required);
    } else {
      this.formularioResumen.get('motivoCosto').setValidators(null);
    }
    this.formularioResumen.get('motivoCosto').updateValueAndValidity();
  }

  cargarMotivosSiniestros(motivos: MotivosResumen[]) {
    if (!motivos?.length) return this.mostrarTablaMotivos = false;
    this.mostrarTablaMotivos = true;
    this.filasMotivo = motivos.map(mot => ({ ...mot, checked: false }));
    this.cargaTablaMotivos();
  }

  verificarTerminoSiniestro() {
    if (isStringNullOrEmpty(this.formularioResumen.get('observaciones').value)) {
      return this.formularioResumen.get('observaciones').markAsTouched();
    }
    const request = {
      moneda: this.data.siniestro.monedak,
      ramo: this.data.siniestro.ramok,
      sramo: this.data.siniestro.sramok,
      oficina: this.data.siniestro.oficinak,
      consecutivo: this.data.siniestro.conseck,
      anio: this.data.siniestro.aak,
      causa: this.siniestroResumenSiniestro.causa,
      costo: this.formularioResumen.get('sinCosto').value ? this.formularioResumen.get('sinCosto').value ? 1 : 2 : undefined,
      motivoCosto: this.formularioResumen.get('motivoCosto').value ?? undefined,
      sucursal: this.siniestroResumenSiniestro.sucursalk1,
      linea: this.siniestroResumenSiniestro.cve_linea,
      producto: this.siniestroResumenSiniestro.cve_prod,
      poliza: this.siniestroResumenSiniestro.polizak1,
      endoso: this.siniestroResumenSiniestro.endosok1,
      a_emision: this.siniestroResumenSiniestro.a_emisionk,
      no_reexpedicion: this.siniestroResumenSiniestro.no_reexpedicionk,
      cve_linea_ind: this.siniestroResumenSiniestro.cve_linea_indk,
      cve_secc_gpo: this.siniestroResumenSiniestro.cve_secc_gpok,
      inciso: this.siniestroResumenSiniestro.num_incisok,
      num_depend: this.siniestroResumenSiniestro.num_dependk,
      fechaSiniestro: this.siniestroResumenSiniestro.fecsini,
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementosWebService.verificaTerminoSiniestro(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.procesaTerminoSiniestro(value.Resultado, value);
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos.' }));
      },
    })
  }

  procesaTerminoSiniestro(resultVerifica: VerificaTerminoSiniestroOutput, resultado: ResultApiResponse<VerificaTerminoSiniestroOutput>) {
    if ((resultVerifica?.requerido) == "false" || resultVerifica?.requerido == null) {
      this.validaGuardaObservaciones(false, true, true);
    } else {
      if ((resultVerifica?.confirmacion) == "false" || resultVerifica?.confirmacion == null) {
        this.procesosComplementoService.alertaGeneralComplemento('Aviso', `${resultado.Mensaje}`, 'warning', true, false);
      } else {
        const html = `¿Desea continuar sin registrar lesionados?<br><br> Nota: <b>'ACEPTAR' para continuar con el cierre del siniestro.</b>`
        this.procesosComplementoService.alertaGeneralComplemento('Aviso', '', 'question', true, true, html).then(result => {
          if (result.isConfirmed) {
            this.validaGuardaObservaciones(false, true, true);
          }
          if (result.isDenied) {
            this.closeDialog('Cerrar');
          }
        });
      }
    }
  }

  validaGuardaObservaciones(mensajeConfirmacion: boolean, validatablatextos: boolean, funcionSiguiente: boolean) {
    this.guardarActualizarObservaciones(mensajeConfirmacion, validatablatextos, funcionSiguiente);
  }

  consultarSiniestroResumen() {
    const request = {
      sucursal: this.siniestroResumenSiniestro.sucursalk1,
      linea: this.siniestroResumenSiniestro.cve_linea,
      producto: this.siniestroResumenSiniestro.cve_prod,
      poliza: this.siniestroResumenSiniestro.polizak1,
      endoso: this.siniestroResumenSiniestro.endosok1,
      a_emision: this.siniestroResumenSiniestro.a_emisionk,
      no_reexpedicion: this.siniestroResumenSiniestro.no_reexpedicionk,
      cve_linea_ind: this.siniestroResumenSiniestro.cve_linea_indk,
      cve_secc_gpo: this.siniestroResumenSiniestro.cve_secc_gpok,
      inciso: this.siniestroResumenSiniestro.num_incisok,
      num_depend: this.siniestroResumenSiniestro.num_dependk,
      fechaSiniestro: this.siniestroResumenSiniestro.fecsini,
      alarma: this.siniestroResumenSiniestro.alarma,
      moneda: this.data.siniestro.monedak,
      ramo: this.data.siniestro.ramok,
      sramo: this.data.siniestro.sramok,
      oficina: this.data.siniestro.oficinak,
      consecutivo: this.data.siniestro.conseck,
      anio: this.data.siniestro.aak,
      causa: this.siniestroResumenSiniestro.causa,
      perfil: this.data.fechasDetalle.Perfil
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementosWebService.consultaResumenSiniestro(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.procesaResultadoResumen(value.Resultado);
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos.' }));
      },
    })
  }

  procesaResultadoResumen(resultResumen: ConsultaResumenSiniestroOutput) {

    const servicios = resultResumen.Modulos.find(mod => mod.nombre == 'Servicios');
    const pagosRecuperaciones = resultResumen.Modulos.find(mod => mod.nombre == 'P&R');
    const ocupantes = resultResumen.Modulos.find(mod => mod.nombre == 'Lesionados');
    const terceros = resultResumen.Modulos.find(mod => mod.nombre == 'Terceros');
    const motivos = resultResumen.Motivos;

    this.serviciosAsegurado = new MatTableDataSource(servicios.Categoria.at(0).contenido);
    this.serviciosTercero = new MatTableDataSource(servicios.Categoria.at(1).contenido);
    this.pagos = new MatTableDataSource(pagosRecuperaciones.Categoria.at(0).contenido);
    this.recuperaciones = new MatTableDataSource(pagosRecuperaciones.Categoria.at(1).contenido);
    this.ocupantesAsegurado = new MatTableDataSource(ocupantes.Categoria.at(0).contenido);
    this.ocupantesTercero = new MatTableDataSource(ocupantes.Categoria.at(1).contenido);
    this.tercerosSiniestro = new MatTableDataSource(terceros.Categoria.at(0).contenido);
    this.coberturasSiniestro = new MatTableDataSource(resultResumen.Coberturas);

    this.estimacionesSiniestro.estimacion = resultResumen.Estimacion;
    this.estimacionesSiniestro.estimacionRCO = resultResumen.SiniestroRCO;
    this.formularioResumen.get('observaciones').setValue(resultResumen.Observaciones);

    this.cargarMotivosSiniestros(motivos);
  }

  guardarActualizarObservaciones(mensajeConfirmacion: boolean, validatablatextos: boolean, funcionSiguiente: boolean) {
    const request = {
      moneda: this.data.siniestro.monedak,
      ramo: this.data.siniestro.ramok,
      sramo: this.data.siniestro.sramok,
      oficina: this.data.siniestro.oficinak,
      consecutivo: this.data.siniestro.conseck,
      anio: this.data.siniestro.aak,
      observaciones: this.formularioResumen.get('observaciones').value,
      validatablatextos: validatablatextos ? 1 : 0
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementosWebService.guardaActualizaObservaciones(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Exito) {
          if (funcionSiguiente) {
            this.actualizarTerminoSiniestro();
          }
          if (mensajeConfirmacion && !funcionSiguiente) {
            this.procesosComplementoService.alertaGeneralComplemento("Guardado", "El registro fue guardado correctamente", "success", false, true);
            this.consultarSiniestroResumen();
          }
        } else {
          this.procesosComplementoService.alertaGeneralComplemento("Aviso", `${value.Mensaje}`, "warning", false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos guardar o actualizar los datos de las observaciones.' }));
      },
    })
  }

  actualizarTerminoSiniestro() {
    const request = {
      sucursal: this.siniestroResumenSiniestro.sucursalk1,
      linea: this.siniestroResumenSiniestro.cve_linea,
      producto: this.siniestroResumenSiniestro.cve_prod,
      poliza: this.siniestroResumenSiniestro.polizak1,
      endoso: this.siniestroResumenSiniestro.endosok1,
      a_emision: this.siniestroResumenSiniestro.a_emisionk,
      no_reexpedicion: this.siniestroResumenSiniestro.no_reexpedicionk,
      cve_linea_ind: this.siniestroResumenSiniestro.cve_linea_indk,
      cve_secc_gpo: this.siniestroResumenSiniestro.cve_secc_gpok,
      inciso: this.siniestroResumenSiniestro.num_incisok,
      num_depend: this.siniestroResumenSiniestro.num_dependk,
      alarma: this.siniestroResumenSiniestro.alarma,
      moneda: this.data.siniestro.monedak,
      ramo: this.data.siniestro.ramok,
      sramo: this.data.siniestro.sramok,
      oficina: this.data.siniestro.oficinak,
      consecutivo: this.data.siniestro.conseck,
      anio: this.data.siniestro.aak,
      causa: this.siniestroResumenSiniestro.causa,
      costo: this.formularioResumen.get('sinCosto').value ? this.formularioResumen.get('sinCosto').value ? 1 : 2 : undefined,
      motivoCosto: this.formularioResumen.get('motivoCosto').value ?? undefined,
      siniestro: `${this.data.siniestro.monedak}-${this.data.siniestro.ramok}-${this.data.siniestro.sramok}-${this.data.siniestro.oficinak}-${this.data.siniestro.conseck}-${this.data.siniestro.aak}`,
      tipoPerdida: this.siniestroResumenSiniestro.cve_perdida_total,
      vehiculo: this.siniestroResumenSiniestro.vehiculo,
      desc_vehiculo: this.siniestroResumenSiniestro.desc_vehiculo,
      responsable: this.siniestroResumenSiniestro.respons_sini,
      fechaOcurrencia: this.siniestroResumenSiniestro.fecsini + " " + this.siniestroResumenSiniestro.horasini,
      fechaRegistro: this.siniestroResumenSiniestro.fecreg + " " + this.siniestroResumenSiniestro.horareg,
      contratante: this.siniestroResumenSiniestro.desc_contratante,
      agente: this.siniestroResumenSiniestro.agente,
      desc_agente: this.siniestroResumenSiniestro.desc_agente,
      idSiniestroAlerta: this.data.siniestroDetalle.IdAlerta,
      perfil: this.data.fechasDetalle.Perfil,
      serie: this.siniestroResumenSiniestro.serie_emision,
      desc_causa: this.siniestroResumenSiniestro.desc_causa,
      desc_subCausa: this.siniestroResumenSiniestro.desc_sub_causa,
      fechaSiniestro: this.siniestroResumenSiniestro.fecsini
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementosWebService.actualizaTerminoSiniestro(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Exito) {
          this.mostrarAlertaComplementoSiniestro(value.Resultado, `${this.data.siniestro.monedak}-${this.data.siniestro.ramok}-${this.data.siniestro.sramok}-${this.data.siniestro.oficinak}-${this.data.siniestro.conseck}-${this.data.siniestro.aak}`);
        } else {
          this.mostrarErrorComplemento(value.Mensaje, `${this.data.siniestro.monedak}-${this.data.siniestro.ramok}-${this.data.siniestro.sramok}-${this.data.siniestro.oficinak}-${this.data.siniestro.conseck}-${this.data.siniestro.aak}`);
        }

      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos.' }));
      },
    })
  }

  mostrarErrorComplemento(mensaje: string, numSiniestro: string) {
    const html = `
      <div style="text-align: center; font-size: 13px;">
        <p>No pudimos complementar el siniestro:</p>
        <p style="font-size: 15px; color: #dc0b3e; margin: 8px 0;">
          <b>${numSiniestro}</b>
        </p>
        <p>por: <b>${mensaje}</b></p>
      </div>
    `;
    this.procesosComplementoService.alertaGeneralComplemento(
      'Aviso',
      '',
      'warning',
      false,
      true,
      html
    ).then(result => {
    });
  }

  mostrarAlertaComplementoSiniestro(data: ActualizaTerminoSiniestroOutput, numSiniestro: string): void {
    const html = `
      <div style="text-align: center; font-size: 13px;">
        <p>Se complementó correctamente el siniestro:</p>
        <p style="font-size: 15px; color: #dc0b3e; margin: 8px 0;">
          <b>${numSiniestro}</b>
        </p>
        <p>por: <b>${data.ajustador}</b></p>
        <p>el día <b>${data.fecha}</b> a las <b>${data.hora}</b></p>
      </div>
    `;
    this.procesosComplementoService.alertaGeneralComplemento(
      'Guardado',
      '',
      'success',
      false,
      true,
      html
    ).finally(() => {
      this.registrarUsuarioPortal();
    });
  }

  registrarUsuarioPortal() {
    this.store.dispatch(ActivarLoadingAction());
    const request = {
      moneda: this.data.siniestro.monedak,
      ramo: this.data.siniestro.ramok,
      sramo: this.data.siniestro.sramok,
      oficina: this.data.siniestro.oficinak,
      consecutivo: this.data.siniestro.conseck,
      anio: this.data.siniestro.aak,
    };
    this.complementosWebService.registraUsuarioPortal(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.closeDialog('Cerrar');
      },
      complete: () => {
        this.router.navigate(['/complemento-web/consulta']);
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos.' }));
      },
    })
  }
}
